// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navigation_nav-container__5u9vB {
  display: grid;
  gap: 8px;
  grid-template-rows: auto 1fr auto;
  padding: 20px;
}

.navigation_profile__vAmjq {
  display: grid;
  gap: 12px;
  grid-template-columns: auto 1fr;
  align-items: center;
}

.navigation_picture-round__RTua3 {
  width: 16px;
  height: 16px;
  border-radius: 6px;
  padding: 10px;
  background-color: var(--secondary-background-color);

  & svg {
    width: inherit;
    height: inherit;
  }
}

.navigation_main-nav-items__w3PZD {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.navigation_footer-nav-items__b33dM {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.navigation_footer__U5pch {
  height: 30px;
  padding: 4px 10px;
}

@media (max-width: 1368px) {
  .navigation_profile-info__2WZOS {
    display: none;
  }

  .navigation_profile__vAmjq {
    display: grid;
    grid-template-columns: 1fr;
    align-items: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/navigation.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,QAAQ;EACR,iCAAiC;EACjC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mDAAmD;;EAEnD;IACE,cAAc;IACd,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,0BAA0B;IAC1B,mBAAmB;EACrB;AACF","sourcesContent":[".nav-container {\n  display: grid;\n  gap: 8px;\n  grid-template-rows: auto 1fr auto;\n  padding: 20px;\n}\n\n.profile {\n  display: grid;\n  gap: 12px;\n  grid-template-columns: auto 1fr;\n  align-items: center;\n}\n\n.picture-round {\n  width: 16px;\n  height: 16px;\n  border-radius: 6px;\n  padding: 10px;\n  background-color: var(--secondary-background-color);\n\n  & svg {\n    width: inherit;\n    height: inherit;\n  }\n}\n\n.main-nav-items {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.footer-nav-items {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.footer {\n  height: 30px;\n  padding: 4px 10px;\n}\n\n@media (max-width: 1368px) {\n  .profile-info {\n    display: none;\n  }\n\n  .profile {\n    display: grid;\n    grid-template-columns: 1fr;\n    align-items: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"nav-container": `navigation_nav-container__5u9vB`,
	"profile": `navigation_profile__vAmjq`,
	"picture-round": `navigation_picture-round__RTua3`,
	"main-nav-items": `navigation_main-nav-items__w3PZD`,
	"footer-nav-items": `navigation_footer-nav-items__b33dM`,
	"footer": `navigation_footer__U5pch`,
	"profile-info": `navigation_profile-info__2WZOS`
};
export default ___CSS_LOADER_EXPORT___;
